<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nome</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_conta"
                        :options="optionsLivTipoConta"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo Conta"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_operacao"
                        :options="optionsLivTipoOperacao"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo Operação"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="concon_id_pai"
                        :options="optionsLivConconPai"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Conta Pai"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      nome: '',
      cd: '',
      optionsLivStatus: [],
      optionsLivTipoConta: [],
      optionsLivTipoOperacao: [],
      optionsLivConconPai: [],
      data_filter: [],
      status: [],
      tp_conta: [],
      tp_operacao: [],
      concon_id_pai: []
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {nome: this.nome,
                              cd: this.cd,
                              status: this.status,
                              tp_conta: this.tp_conta,
                              tp_operacao: this.tp_operacao,
                              concon_id_pai: this.concon_id_pai}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.nome = '';  // clear the text in text input
        this.cd = '';
        this.status = '';
        this.tp_conta = '';
        this.tp_operacao = '';
        this.concon_id_pai = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral() {
          this.helpForm.get('/api/contacontabil/jsonlistgeral').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.status.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              })
              response.tp_conta.forEach((obj)=>
              {
                  this.optionsLivTipoConta.push({ label: obj.descr, value: obj.valor })
              })
              response.tp_operacao.forEach((obj)=>
              {
                  this.optionsLivTipoOperacao.push({ label: obj.descr, value: obj.valor })
              })
              response.conta_contabil.forEach((obj)=>
              {
                  this.optionsLivConconPai.push({ label: obj.descr, value: obj.concon_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
